import React from "react";
import classNames from "classnames";

import IDHFormattedMessage from "src/app/components/IDHFormattedMessage/IDHFormattedMessage";
import { ReactComponent as CrossGreyIcon } from "src/images/close.svg";

const BASE_ICON_CLASS = "audience-search__label__icon";

function AudienceFilterLabel({
  children,
  id,
  defaultMessage,
  removeFilter,
  disabled,
  toggleFilter,
  isActive = true,
  className,
}) {
  const handleRemoveClick = (e) => {
    e.stopPropagation();
    removeFilter();
  };

  const handleToggleClick = (e) => {
    e.stopPropagation();
    toggleFilter();
  };

  const renderLabelContent = () => {
    if (children) {
      return (
        <>
          {defaultMessage && (
            <>
              <IDHFormattedMessage id={id} defaultMessage={defaultMessage} />:
              &nbsp;
            </>
          )}
          {children}
        </>
      );
    }

    if (defaultMessage) {
      return <IDHFormattedMessage id={id} defaultMessage={defaultMessage} />;
    }

    return null;
  };

  return (
    <div
      key={id}
      className={classNames(
        "audience-search__label audience-search__label--grey",
        {
          "audience-search__label--disabled": disabled,
          "audience-search__label--inactive": !isActive,
          "audience-search__label--clickable": toggleFilter,
        },
        className,
      )}
      onClick={toggleFilter ? handleToggleClick : undefined}
      data-filter-type={id}
      data-filter-value={
        children && typeof children[0] !== "undefined" ? children[0] : ""
      }
    >
      {renderLabelContent()}
      {isActive && removeFilter && (
        <CrossGreyIcon
          onClick={handleRemoveClick}
          className={BASE_ICON_CLASS}
          width={16}
          height={16}
        />
      )}
      {!isActive && toggleFilter && (
        <CrossGreyIcon
          onClick={handleToggleClick}
          className={`${BASE_ICON_CLASS} audience-search__label__toggle`}
          width={16}
          height={16}
        />
      )}
    </div>
  );
}

export default AudienceFilterLabel;
